import { render } from "./customsea.vue?vue&type=template&id=27f3581e"
import script from "./customsea.vue?vue&type=script&lang=js"
export * from "./customsea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__